module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vfcarm3-dc04b865ac86dacf7f4b0a87b468f47c.jpg";